

const Settings = () => {
  return (
    <div className="container py-5">
      <h2>Settings</h2>
      <p>Update your profile and account preferences here.</p>
    </div>
  );
};

export default Settings;

